<template>
	<div id="join-newsletter">
		<form @submit.prevent="signUp">
			<div class="col-row">
				<div class="col s12 m6 l6">
					<div class="form-block">
						<label class="form-label required" data-key="firstname">
							<span class="label">Firstname</span>
							<div class="form-field input">
								<input v-model="model.customFields.firstname" placeholder="Enter your firstname" type="input" class="field">
							</div>
						</label>
					</div>
				</div>
				<div class="col s12 m6 l6">
					<div class="form-block">
						<label class="form-label required" data-key="lastname">
							<span class="label">Lastname</span>
							<div class="form-field input">
								<input v-model="model.customFields.lastname" placeholder="Enter your lastname" type="input" class="field">
							</div>
						</label>
					</div>
				</div>
			</div>
			<div class="form-block">
				<label class="form-label required" data-key="email">
					<span class="label">Email address</span>
					<div class="form-field input">
						<input v-model="model.email" placeholder="example@email.com" type="email" maxlength="64" class="field">
					</div>
				</label>
			</div>
			<div class="form-block">
				<label class="form-label required" data-key="country">
					<span class="label">Country</span>
					<div class="form-field select">
						<select class="field" v-model="model.customFields.country">
							<option value="" selected disabled>Select your country</option>
							<option v-for="country in list.country" :value="country">{{ country }}</option>
						</select>
					</div>
				</label>
			</div>
			<div class="form-block" v-if="model.customFields.country === 'United Kingdom'">
				<label class="form-label required" data-key="postcode">
					<span class="label">Post code</span>
					<div class="form-field input">
						<input v-model="model.customFields.postcode" placeholder="Enter your post code" type="text" minlength="6" maxlength="8" class="field">
					</div>
				</label>
			</div>
			<div class="form-block">
				<label class="form-label required" data-key="diabetes_relationship">
					<span class="label">What is your relationship with diabetes?</span>
					<div class="form-field select">
						<select class="field" v-model="model.customFields.diabetes_relationship">
							<option value="" selected disabled>Select from list</option>
							<option v-for="option in list.diabetes_relationship" :value="option">{{ option }}</option>
						</select>
					</div>
				</label>
			</div>
			<div class="form-block" v-if="hasDiabetes">
				<label class="form-label required" data-key="diabetes_type">
					<span class="label">What type of diabetes do you/they have?</span>
					<div class="form-field select">
						<select class="field" v-model="model.customFields.diabetes_type">
							<option value="" selected disabled>Select from list</option>
							<option v-for="option in list.diabetes_type" :value="option">{{ option }}</option>
						</select>
					</div>
				</label>
			</div>
			<div class="form-block">
				<div class="form-label required" data-key="diabetes_treatment">
					<span class="label">How do you treat your diabetes?</span>
					<div class="ui-checkbox" v-for="treatment, key in list.diabetes_treatment">
						<label>
							<input type="checkbox" :value="treatment" v-model="model.customFields.diabetes_treatment" />
							<span class="checkbox"></span>
							<span v-text="treatment"></span>
						</label>
					</div>
				</div>
			</div>
			<div class="form-block">
				<div class="form-label required" data-key="subscribe">
					<span class="label">Select your subscription newsletters:</span>
					<div class="ui-checkbox" v-for="subscribe, key in list.subscribe_options">
						<label>
							<input type="checkbox" :value="subscribe" v-model="model.subscribe" />
							<span class="checkbox"></span>
							<span v-text="transformSubscribeLabel(subscribe)"></span>
						</label>
					</div>
				</div>
			</div>
			<div class="ui-switch">
				<div class="switch">
					<input type="checkbox" v-model="model.terms" />
					<span class="handle"></span>
				</div>
				<p>I agree to the <a :href="`${$app.site_url}/disclaimer.html`">Terms &amp; Conditions</a></p>
			</div>
			<div class="ui-switch">
				<div class="switch">
					<input type="checkbox" v-model="model.privacy" />
					<span class="handle"></span>
				</div>
				<p>I agree to the <a :href="`${$app.site_url}/privacy.html`">Privacy Policy</a></p>
			</div>
			<div class="submit">
				<button type="submit" class="ui-btn ui-btn-block ui-btn-radius" :disabled="sending || !model.privacy || !model.terms" v-text="sending ? 'Subscribing...' : 'Subscribe'"></button>
			</div>
		</form>
	</div>
</template>
<script>
	import {campaignerApi} from '../../api';
	import {startCase, replace} from 'lodash';
	export default {
		data () {
			return {
				loaded: false,
				sending: false,
				list: {
					diabetes_relationship: [
						"I have diabetes",
						"Other family member/friend has diabetes",
						"Healthcare professional",
						"Prefer not to say",
						"None",
					],
					diabetes_type: [
						"Type 1",
						"Type 1.5/LADA",
						"Type 2",
						"In remission",
						"MODY",
						"Gestational",
						"Type 3c",
						"Cystic Fibrosis Diabetes",
						"Steroid Induced Diabetes",
						"Alstrom Syndrome",
						"Neonatal Diabetes",
						"Other",
					],
					diabetes_treatment: [
						"Diet and exercise",
						"Tablets",
						"Tablets and injections other than insulin",
						"Tablets and insulin",
						"Insulin",
						"Prefer not to say",
						"None",
					],
					country: [
						"United Kingdom",
						"Afghanistan",
						"Åland Islands",
						"Albania",
						"Algeria",
						"American Samoa",
						"Andorra",
						"Angola",
						"Anguilla",
						"Antarctica",
						"Antigua and Barbuda",
						"Argentina",
						"Armenia",
						"Aruba",
						"Australia",
						"Austria",
						"Azerbaijan",
						"Bahamas",
						"Bahrain",
						"Bangladesh",
						"Barbados",
						"Belarus",
						"Belgium",
						"Belize",
						"Benin",
						"Bermuda",
						"Bhutan",
						"Bolivia",
						"Bosnia and Herzegovina",
						"Botswana",
						"Bouvet Island",
						"Brazil",
						"British Indian Ocean Territory",
						"British Virgin Islands",
						"Brunei",
						"Bulgaria",
						"Burkina Faso",
						"Burundi",
						"Cambodia",
						"Cameroon",
						"Canada",
						"Cape Verde",
						"Cayman Islands",
						"Central African Republic",
						"Chad",
						"Chile",
						"China",
						"Christmas Island",
						"Cocos (Keeling) Islands",
						"Colombia",
						"Comoros",
						"Cook Islands",
						"Costa Rica",
						"Cote d'Ivoire",
						"Croatia",
						"Cuba",
						"Curaçao",
						"Cyprus",
						"Czech Republic",
						"Democratic Republic of the Congo",
						"Denmark",
						"Djibouti",
						"Dominica",
						"Dominican Republic",
						"East Timor",
						"Ecuador",
						"Egypt",
						"El Salvador",
						"Equatorial Guinea",
						"Eritrea",
						"Estonia",
						"Ethiopia",
						"Falkland Islands (Malvinas",
						"Faroe Islands",
						"Fiji",
						"Finland",
						"France",
						"France, Metropolitan",
						"French Guiana",
						"French Polynesia",
						"French Southern and Antarctic Lands",
						"Gabon",
						"Gambia",
						"Georgia",
						"Germany",
						"Ghana",
						"Gibraltar",
						"Greece",
						"Greenland",
						"Grenada",
						"Guadeloupe",
						"Guam",
						"Guatemala",
						"Guernsey",
						"Guinea",
						"Guinea-Bissau",
						"Guyana",
						"Haiti",
						"Heard Island and McDonald Islands",
						"Honduras",
						"Hong Kong",
						"Hungary",
						"Iceland",
						"India",
						"Indonesia",
						"Iran",
						"Iraq",
						"Ireland",
						"Isle of Man",
						"Israel",
						"Italy",
						"Jamaica",
						"Japan",
						"Jersey",
						"Jordan",
						"Kazakhstan",
						"Kenya",
						"Kiribati",
						"Kosovo",
						"Kuwait",
						"Kyrgyzstan",
						"Laos",
						"Latvia",
						"Lebanon",
						"Lesotho",
						"Liberia",
						"Libya",
						"Liechtenstein",
						"Lithuania",
						"Luxembourg",
						"Macau",
						"Madagascar",
						"Malawi",
						"Malaysia",
						"Maldives",
						"Mali",
						"Malta",
						"Marshall Islands",
						"Martinique",
						"Mauritania",
						"Mauritius",
						"Mayotte",
						"Mexico",
						"Micronesia, Federated States of",
						"Moldova",
						"Monaco",
						"Mongolia",
						"Montenegro",
						"Montserrat",
						"Morocco",
						"Mozambique",
						"Myanmar (Burma",
						"Namibia",
						"Nauru",
						"Nepal",
						"Netherlands",
						"Netherlands Antilles",
						"New Caledonia",
						"New Zealand",
						"Nicaragua",
						"Niger",
						"Nigeria",
						"Niue",
						"Norfolk Island",
						"North Korea",
						"North Macedonia",
						"Northern Mariana Islands",
						"Norway",
						"Oman",
						"Pakistan",
						"Palau",
						"Palestine",
						"Panama",
						"Papua New Guinea",
						"Paraguay",
						"Peru",
						"Philippines",
						"Pitcairn Islands",
						"Poland",
						"Portugal",
						"Puerto Rico",
						"Qatar",
						"Republic of the Congo",
						"Réunion",
						"Romania",
						"Russia",
						"Rwanda",
						"Saint Barthélemy",
						"Saint Helena",
						"Saint Kitts and Nevis",
						"Saint Lucia",
						"Saint Martin",
						"Saint Pierre and Miquelon",
						"Saint Vincent and the Grenadines",
						"Samoa",
						"San Marino",
						"Sao Tome and Principe",
						"Saudi Arabia",
						"Senegal",
						"Serbia",
						"Seychelles",
						"Sierra Leone",
						"Singapore",
						"Sint Maarten",
						"Slovakia",
						"Slovenia",
						"Solomon Islands",
						"Somalia",
						"South Africa",
						"South Georgia South Sandwich Islands",
						"South Korea",
						"South Sudan",
						"Spain",
						"Sri Lanka",
						"Sudan",
						"Suriname",
						"Svalbard and Jan Mayen",
						"Swaziland",
						"Sweden",
						"Switzerland",
						"Syria",
						"Taiwan",
						"Tajikistan",
						"Tanzania",
						"Thailand",
						"Togo",
						"Tokelau",
						"Tonga",
						"Trinidad and Tobago",
						"Tunisia",
						"Turkey",
						"Turkmenistan",
						"Turks and Caicos Islands",
						"Tuvalu",
						"U.S. Virgin Islands",
						"Uganda",
						"Ukraine",
						"United Arab Emirates",
						"United States",
						"United States Minor Outlying Islands",
						"Uruguay",
						"Uzbekistan",
						"Vanuatu",
						"Vatican City",
						"Venezuela",
						"Vietnam",
						"Wallis and Futuna",
						"Western Sahara",
						"Yemen",
						"Zambia",
						"Zimbabwe",
					],
					subscribe_options: [
						"weekly_newsletter",
						"type_1_diabetes_newsletter",
						"type_2_diabetes_newsletter",
						"food_and_recipes",
						"forum_updates",
						"paid_clinical_trials_and_research",
						"offers_and_freebies",
						"competitions",
						"technology",
						"education",
						"prediabetes",
						"parents_of_children_with_type_1",
						"parents_of_children_with_type_2",
						"healthcare_professionals",
					]
				},
				model: {
					email: "",
					customFields: {
						firstname: "",
						lastname: "",
						"country": "",
						"diabetes_relationship": "",
						"diabetes_treatment": [],
						"diabetes_type": "",
						"postcode": "",
					},
					terms: false,
					privacy: false,
					subscribe: []
				}
			}
		},
		methods: {
			subscribe() {
				let self = this;
				self.sending = true;
				$('span.error').remove();
				campaignerApi.subscribe(self.model).then(response => {
					self.sending = false;
					let res = response.data;
					if(!res.error) {
						alert(res.message);
						window.location.href = self.$app.site_url + '/thanks';
					}
				}, (error) => {
					self.sending = false;
					let errors = error.response.data;
					console.log(errors);
					if(errors.errors) {
						Object.entries(errors.errors).forEach((value, index) => {
							$('[data-key="' + value[0] + '"]').append('<span class="error">' + value[1] + '</span>');
						});
					} else {
						alert('Something went wrong, please try again later');
					}
					console.log(error);
				});
			},
			signUp() {
				let self = this;
				self.subscribe();
			},
			transformSubscribeLabel(text) {
				return startCase(replace(text, /_/g, ' '));
			},
			initMounted() {
				let self = this;
				self.loaded = true;
			}
		},
		computed: {
			hasDiabetes() {
				let self = this,
					diabetes_relationship = self.model.customFields.diabetes_relationship;
				if(diabetes_relationship === "I have diabetes" || diabetes_relationship === "Other family member/friend has diabetes") {
					return true;
				}
				return false;
			}
		},
		mounted() {
			let self = this;
			self.initMounted();
		}
	}
</script>